import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { SwiperConfigInterface, SwiperComponent } from 'ngx-swiper-wrapper';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-slider-cards-articles',
  templateUrl: './slider-cards-articles.component.html',
  styleUrls: ['./slider-cards-articles.component.scss'],
})
export class SliderCardsArticlesComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() data: any[] = [];
  @Input() background: string = '';
  @Input() items: any = [];
  @Input() loading: boolean;
  loaded: boolean;
  config: SwiperConfigInterface = {
    loop: this.items.length > 2,
    observer: true,
    slidesPerView: 2,
    spaceBetween: 14,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: '.slider-product-next',
      prevEl: '.slider-product-prev',
    },
    breakpoints: {
      768: {
        loop: this.items.length > 3,
        slidesPerView: 3,
        spaceBetween: 27,
      },
      1024: {
        loop: this.items.length > 4,
        slidesPerView: 4,
        spaceBetween: 27,
      },
    },
  };
  @ViewChild('swiper')
  swiper: SwiperComponent;
  hideArrows: boolean = false;
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      setTimeout(() => {
        this.config = {
          loop: this.items.length > 2,
          observer: true,
          slidesPerView: 2,
          spaceBetween: 14,
          preloadImages: false,
          lazy: true,
          breakpoints: {
            768: {
              loop: this.items.length > 3,
              slidesPerView: 3,
              spaceBetween: 27,
            },
            1024: {
              loop: this.items.length > 4,
              slidesPerView: 4,
              spaceBetween: 27,
            },
          },
        };

        this.hideNavOnResize();
      }, 1000);
    }
  }

  navigate(goTo: 'next' | 'prev') {
    if (goTo === 'next') {
      return this.swiper.directiveRef.swiper().slideNext();
    }

    return this.swiper.directiveRef.swiper().slidePrev();
  }

  hideNav(scroll) {
    if (scroll < 768 && this.items.length < 2) {
      return (this.hideArrows = true);
    } else if (scroll < 1024 && this.items.length < 3) {
      return (this.hideArrows = true);
    } else if (scroll > 1024 && this.items.length < 4) {
      return (this.hideArrows = true);
    } else {
      return (this.hideArrows = false);
    }
  }

  hideNavOnResize() {
    let scroll = document.documentElement.clientWidth;
    this.hideNav(scroll);

    window.addEventListener('resize', (e) => {
      scroll = document.documentElement.clientWidth;
      this.hideNav(scroll);
    });
  }
}
